import RequestUtils from "utils/RequestUtils";

export default class LineApi {
  private constructor() {}

  public static async getStatus(castId: number) {
    return await RequestUtils.getPlain(`/line/status/${castId}`);
  }

  public static async link(castId: number, lineUserId: string) {
    return await RequestUtils.postVoid(`/line/link/${castId}`, { lineUserId });
  }

  public static async unlink(castId: number) {
    return await RequestUtils.postVoid(`/line/unlink/${castId}`, {});
  }

  public static async updateNotifyMethod(
    castId: number,
    notifyMethod: string
  ) {
    // PUT is not available, use postVoid
    return await RequestUtils.postVoid(`/line/notifyMethod/${castId}`, {
      notifyMethod,
    });
  }
}
